import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrentViewPropertySession } from 'src/hooks/use-current-view-property-session';
import Typography from '~components/typography';

const useStyles = makeStyles(
  (theme) => ({
    root: {
      marginBottom: 12,
      cursor: 'pointer',

      '&:hover $fullName': {
        color: theme.colors.brandAction,
      },
    },

    mainlyInfo: {
      ...theme.flex.crossCenter,
    },

    fullName: {
      color: theme.colors.dark,
    },

    relationship: {
      display: 'inline-block',
      backgroundColor: theme.colors.greyE8,
      borderRadius: theme.borderRadius.huge,
      padding: '1px 8px',
      justifyContent: 'flex-end',
      marginLeft: '8px',
      transform: 'translateY(-2px)',
    },

    contactEmail: {
      marginTop: 4,
      wordBreak: 'break-all',
    },
  }),
  { name: 'ContactCard' }
);

function ContactCard({ contact, isGuarantor }) {
  const { t } = useTranslation(['graphql']);
  const classes = useStyles();

  const { fullName, relationship, contactEmail, studentId, bookingId } = contact;

  const [
    {
      currentViewProperty: { id: propertyId },
    },
  ] = useCurrentViewPropertySession();

  const openStudentDetailPage = () => {
    if (isGuarantor) {
      const studentDetailsUrl = queryString.stringifyUrl({
        url: '/booking/booking-details',
        query: { originBookingId: JSON.parse(atob(bookingId))?.id },
      });
      window.open(studentDetailsUrl);
    } else {
      const studentDetailsUrl = queryString.stringifyUrl({
        url: '/student/student-details/personal-information',
        query: { studentId, propertyId },
      });
      window.open(studentDetailsUrl);
    }
  };

  return (
    <div
      className={classes.root}
      onClick={() => {
        openStudentDetailPage();
      }}
    >
      <div className={classes.mainlyInfo}>
        <Typography variant="body1" themeColor="dark" className={classes.fullName}>
          {fullName}
          {relationship && (
            <Typography variant="caption" themeColor="grey66" className={classes.relationship}>
              {t(`graphql:relationship.${relationship}`)}
            </Typography>
          )}
        </Typography>
      </div>

      {contactEmail && (
        <Typography variant="body2" themeColor="grey99" className={classes.contactEmail}>
          {contactEmail}
        </Typography>
      )}
    </div>
  );
}

ContactCard.prototype = {
  contact: PropTypes.object.isRequired,
  isGuarantor: PropTypes.bool,
};

ContactCard.defaultProps = {
  isGuarantor: false,
};

export default ContactCard;
